import React, {useEffect, useState} from 'react';
import {Block, BlockHead, BlockHeadContent, BlockTitle} from '../../../components/block/Block';
import Button from '../../../components/button/Button';
import Icon from '../../../components/icon/Icon';
import {Card} from 'reactstrap';
import {Pagination} from '../../../components/pagination/Pagination';
import {useNavigate} from 'react-router-dom';
import {usePagination} from '../../../shared/hooks/usePagination';
import {formatApi} from '../../../api';
import FormatTable from './components/FormatTable';
import FormatFilters from './components/FormatFilters';
import {IFormat} from './interfaces/IFormat';
import {useTranslation} from 'react-i18next';

const Format = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [formatList, setFormatList] = useState<IFormat[]>([]);

  const {changeFilterHandler, page, setTotalPages, totalPages, handlePages, pagination} = usePagination();

  useEffect(() => {
    formatApi.getAllFormats(pagination).then((response) => {
      const {data} = response;
      setFormatList(data.data);
      setTotalPages(Math.ceil(data?.count / data?.perPage));
    });
  }, [pagination, setTotalPages]);
  return (
    <>
      <Block size="lg" className="mt-3">
        <BlockHead>
          <BlockHeadContent>
            <div className="row align-items-center gx-0 gx-lg-2">
              <div className="col-xxl-10 col-xl-9 col-lg-8 col-12">
                <BlockTitle tag="h4">{t('administrator.formats.formatList')}</BlockTitle>
              </div>
              <div className="col-xxl-2 col-xl-3 col-lg-4 col-12  text-end">
                <Button
                  className="btn-block"
                  color="primary"
                  onClick={() => {
                    navigate('/app/admin/format/create');
                  }}
                >
                  <Icon name="plus-sm" />
                  {t('administrator.formats.addNew')}
                </Button>
              </div>
            </div>
            <FormatFilters changeFilterHandler={changeFilterHandler} pagination={pagination} />
          </BlockHeadContent>
        </BlockHead>
        <Card className="card-bordered card-preview">
          <FormatTable formatList={formatList} setFormatList={setFormatList} />
        </Card>
      </Block>

      <div className="d-flex justify-content-end">
        {totalPages <= 1 ? '' : <Pagination page={page} totalPages={totalPages} handlePagination={handlePages} />}
      </div>
    </>
  );
};

export default Format;
